import { Box, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { NavLink, NavLinkProps } from 'react-router-dom';
import {
  getChildNavButtonStyles,
  getNavChildIndicatorStyles,
  getNavItemChildLayoutStyles,
} from './nav-item-styles';

export type NavItemChildProps = {
  label: string;
  to: string;
  isActive?: NavLinkProps['isActive'];
  /** When set, shown left of the label and replaces the active primary dot (e.g. station icon). */
  icon?: React.ReactNode;
  /** Compact layout for collapsed hover popover (dot must not overlap the label). */
  inPopover?: boolean;
};

/** Nested sidenav link under an expandable parent. */
export function NavItemChild({ label, to, isActive, icon, inPopover = false }: NavItemChildProps) {
  const hasIcon = Boolean(icon);

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        component={NavLink}
        to={to}
        isActive={isActive}
        disableRipple
        sx={[
          (theme) => getChildNavButtonStyles(theme, { hasIcon, inPopover }),
          getNavItemChildLayoutStyles(inPopover),
        ]}
      >
        {icon && (
          <Box
            className="nav-child-indicator"
            sx={(theme) => getNavChildIndicatorStyles(theme, inPopover)}
          >
            {icon}
          </Box>
        )}
        <ListItemText primary={label} />
      </ListItemButton>
    </ListItem>
  );
}
